// extracted by mini-css-extract-plugin
export var header = "_xc-1";
export var maskBottom = "_xc-6";
export var maskMiddle = "_xc-7";
export var maskTop = "_xc-5";
export var root = "_xc-0";
export var scrollDownButton = "_xc-3";
export var scrollDownButtonHidden = "_xc-4";
export var viewport = "_xc-2";